export default __webpack_public_path__ + "static/media/css.bd9f1a2a.png";